import { render, staticRenderFns } from "./Overlay.vue?vue&type=template&id=2fab41ec&scoped=true&"
import script from "./Overlay.vue?vue&type=script&lang=js&"
export * from "./Overlay.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/Overlay-pc.css?vue&type=style&index=0&id=2fab41ec&scoped=true&lang=css&"
import style1 from "../assets/css/Overlay-phone.css?vue&type=style&index=1&id=2fab41ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab41ec",
  null
  
)

export default component.exports